import { createMiddlewareAction } from "./createMiddlewareAction";
import { endpointsBackOffice } from "../api/endpoints";
import { userTypes } from "../constantes/actionTypes";

export const usersActions = {
  getUserById: (idUser) =>
    createMiddlewareAction({
      successType: userTypes.GET_USER_BY_IDUSER_SUCCESS,
      failureType: userTypes.GET_USER_BY_IDUSER_FAILURE,
      method: "GET",
      endpoint: endpointsBackOffice.GET_USER_BY_IDUSER(idUser),
    }),

  getAllUsers: () =>
    createMiddlewareAction({
      // llamada a la api pasando el usuario y password por body
      successType: userTypes.GET_ALL_USERS_SUCCESS,
      failureType: userTypes.GET_ALL_USERS_FAILURE,
      method: "GET",
      endpoint: endpointsBackOffice.ALL_USERS,
    }),
  deleteUserById: (idUser) =>
    createMiddlewareAction({
      successType: userTypes.DELETE_USER_SUCCESS,
      failureType: userTypes.DELETE_USER_FAILURE,
      method: "DELETE",
      endpoint: endpointsBackOffice.DELETE_USER_BY_IDUSER(idUser),
    }),
  updateUser: (user) =>
    createMiddlewareAction({
      successType: userTypes.UPDATE_USER_SUCCESS,
      failureType: userTypes.UPDATE_USER_FAILURE,
      method: "PUT",
      endpoint: endpointsBackOffice.UPDATE_USER,
      body: user,
    }),
  newUser: (user) =>
    createMiddlewareAction({
      successType: userTypes.NEW_USER_SUCCESS,
      failureType: userTypes.NEW_USER_FAILURE,
      method: "POST",
      endpoint: endpointsBackOffice.NEW_USER,
      body: user,
    }),
};
